export default "__VITE_PUBLIC_ASSET__eb0bbef8__"